import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

const delayFn = (ms = 1000) => of(1).pipe(delay(ms)).toPromise();
export { delayFn as delay };
